export enum MediaViewMode {
    Portrait = 'portrait',
    Landscape = 'landscape',
    Detail = 'detail',
}
